import React from 'react';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';

const propTypes = {
  pagination: PropTypes.object.isRequired,
  handlePageChange: PropTypes.func.isRequired,
}

export const setPageCount = (total, perPage) => Math.ceil(total / perPage);
export const changePage = (selected, cb) => cb({ page: selected + 1 });

const WithPagination = (Component) => {
  const wrapper = ({ pagination, handlePageChange, ...rest }) => {
    return (
      <div>
        <Component {...rest} />

        <ReactPaginate
          pageCount={setPageCount(pagination.total, pagination.perPage)}
          onPageChange={({ selected }) => changePage(selected, handlePageChange)}
          forcePage={pagination.page - 1}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
        />
      </div>
    );
  };

  wrapper.propTypes = propTypes;
  return wrapper;
};

export default WithPagination;



// WEBPACK FOOTER //
// ./src/components/WithPagination.js